export const BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_REQUEST = 'BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_REQUEST';
export const BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_SUCCESS = 'BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_SUCCESS';
export const BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_ERROR = 'BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_ERROR';

export const BOUNDARY_TERRITORY_DETAILS_UPDATE_MANUAL_ASSIGNMENTS = 'BOUNDARY_TERRITORY_DETAILS_UPDATE_MANUAL_ASSIGNMENTS';
